import { useMutation, useQueryClient } from '@tanstack/react-query'
import { ApiError, hasLiveApi } from '@/api/client'
import { deleteBlockedIp, saveBlockedIpAddress } from '@/api/map/blockedIps'

export function useSaveBlockedIp() {
  const client = useQueryClient()
  return useMutation({
    mutationFn: async (input: { IP: string; comment?: string }) => {
      if (!hasLiveApi()) {
        throw new ApiError(503, 'Hierarchy API is not configured', null)
      }
      const IP = input.IP.trim()
      if (!IP) {
        throw new ApiError(400, 'Please provide an IP address', null)
      }
      const res = await saveBlockedIpAddress({
        IP,
        comment: input.comment?.trim() ?? '',
      })
      if (!res.value) {
        throw new ApiError(409, res.error || 'Unable to block IP', res)
      }
      return res
    },
    onSuccess: () => {
      void client.invalidateQueries({ queryKey: ['blocked-ips'] })
    },
  })
}

export function useDeleteBlockedIp() {
  const client = useQueryClient()
  return useMutation({
    mutationFn: async (input: { id: string; ip?: string; comment?: string }) => {
      if (!hasLiveApi()) {
        throw new ApiError(503, 'Hierarchy API is not configured', null)
      }
      const id = input.id.trim()
      if (!id) {
        throw new ApiError(400, 'Unable to delete IP', null)
      }
      const res = await deleteBlockedIp({
        _id: id,
        IP: input.ip,
        comment: input.comment,
      })
      if (!res.value) {
        throw new ApiError(409, res.error || 'Unable to delete IP', res)
      }
      return res
    },
    onSuccess: () => {
      void client.invalidateQueries({ queryKey: ['blocked-ips'] })
    },
  })
}
